// syncMode is the source of truth for SSO user provisioning: "jit" and
// "jit_users_and_groups" both create accounts on SSO login (they differ only in whether
// group membership is synced too). In "scim" mode the IdP owns the user lifecycle
// through the SCIM endpoints, and "off" means invite-only.
export function jitUserProvisioningEnabled(provider: {
  syncMode: string | null;
}): boolean {
  return (
    provider.syncMode === "jit" || provider.syncMode === "jit_users_and_groups"
  );
}
